// routes/router.tsx
import { useRoutes, Navigate } from 'react-router-dom';
import AuthenticationRoutes from './AuthenticationRoutes';
import AdminRoutes from './AdminRoutes';
import ForbiddenPage from '@/pages/ForbiddenPage';

const Routes = () => {
  return useRoutes([
    // Add a root path redirect to the dashboard
    {
      path: '/',
      element: <Navigate to="/dashboard" replace />
    },
    AuthenticationRoutes,
    AdminRoutes,
    {
      path: '/forbidden',
      element: <ForbiddenPage />
    }
  ]);
};

export default Routes;